// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2465":"d5983387","3630":"d5983387","4675":"d5983387","5109":"c62dcc09","6533":"6275adc6","6909":"d5983387","9248":"d5983387","9464":"d5983387","9525":"d5983387"}[chunkId] + ".chunk.css";
};